import React from "react";
import Slider from "react-slick";
import styles from "./BuddyhoodSlider.module.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import bannerImage3 from "../../../assets/brick.png";

const members = [
  { name: "IONA", img: "/Images/Iona.png" },
  { name: "AMOR", img: "/Images/AMOR.png" },
  { name: "MIA", img: "/Images/MIA.png" },
  { name: "IHAKA", img: "/Images/Ihaka.png" },
  { name: "AIDHAN", img: "/Images/Aidhan.png" },
  { name: "Rudi AI Chatbot", img: "/Images/rudi.png" },
  { name: "Dr Baldr Johannsen", img: "/Images/Johannsen.png" },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 5.5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
      },
    },
  ],
};

const BuddyhoodSlider = () => {
  return (
    <div className={styles.buddyhoodSection} style={{
                background: `url(${bannerImage3}) no-repeat top center/cover`,
              }}>
      <h2>
        Meet The <span className={styles.highlight}>Buddyhood</span>
      </h2>
      <p className={styles.description}>
        Five Young Minds, One Mission - Untangle the Web of Misinformation and
        Save the World, United in Purpose.
      </p>
      <p className={styles.subDescription}>
        An alliance forged in the face of adversity, The Buddyhood unites
        strength, wit, and compassion. From the quiet grace-challenging norms to
        the resilient spirit born of hardship, they defy societal boundaries.
        Together, they tackle the ominous threat, combating misinformation with
        intelligence, humour, and a shared commitment to equality.
      </p>
      <p className={styles.subDescription}>
        Each member, unique in their struggles, forms an integral part of this
        formidable collective. As they unravel the mysteries threatening
        humanity, their bond grows stronger, proving that unity, authenticity,
        and hope can overcome the darkest challenges.
      </p>
      <Slider {...settings} className={styles.slider}>
        {members.map((member, idx) => (
          <div key={idx} className={styles.slide}>
            <img src={member.img} alt={member.name} className={styles.image} />
            <div className={styles.name}>{member.name}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BuddyhoodSlider;
